import MemberProfileAvatar from "app/components/MemberProfileAvatar";
import MemberSelection from "app/containers/Features/components/MemberSelection";
import {
  filterActiveTeamMembers,
  getMembersByIds,
} from "app/containers/Features/components/MemberSelection/helper";
import { selectProjectMemberList } from "app/containers/Features/components/MemberSelection/redux/selector";
import {
  IMemberList
} from "app/containers/Features/components/MemberSelection/types";
import AvatarGroup from "app/containers/Features/containers/TeamSettings/components/AvatarGroup";
import clsx from "clsx";
import React, { useMemo } from "react";
import { useSelector } from "react-redux";

interface Props {
  onSelect: (val: string | string[]) => void;
  value: string | string[];
  placeholder?: string;
  error?: string;
  isMultiSelect: boolean;
}

const TeamMemberSelection: React.FC<Props> = ({
  onSelect,
  value,
  placeholder,
  error,
  isMultiSelect,
}) => {
  const members = useSelector(selectProjectMemberList);
  const activeMember = filterActiveTeamMembers(members);

  const sourceOptions = activeMember;

  const owners = useMemo(() => {
    return getMembersByIds(sourceOptions, value);
  }, [sourceOptions, value]);

  const handleSelect = (member: IMemberList) => {
    if (isMultiSelect) {
      const current = Array.isArray(value) ? value : [];
      const updatedIds = current.includes(member._id)
        ? current.filter((id) => id !== member._id)
        : [...current, member._id];

      onSelect(updatedIds);
    } else {
      onSelect(member._id);
    }
  };

  const isAllSelected = isMultiSelect && owners.length === sourceOptions.length;

  const handleSelectAll = () => {
    if (!isMultiSelect) return;

    if (isAllSelected) {
      onSelect([]);
    } else {
      const allIds = sourceOptions.map((item) => item._id);
      onSelect(allIds);
    }
  };

  const hasValue = Array.isArray(value) ? value.length > 0 : !!value;

  return (
    <div className="w-full relative h-full ">
      <MemberSelection
        trigger={
          <button
            className={clsx(
              "h-[42px] w-full min-h-max data-[state=open]:border-secondary data-[state=open]:outline-secondary data-[state=open]:border text-start px-3 text-sm text-black",
              error && "border-danger",
            )}
          >
            {hasValue ? (
              <div className="flex items-center gap-1 w-full truncate ">
                {isMultiSelect ? (
                  <AvatarGroup
                    membersIds={
                      Array.isArray(value) ? value : value ? [value] : []
                    }
                    maxVisible={10}
                    className=" !w-6 !h-6 "
                    memberListData={activeMember}
                  />
                ) : (
                  <MemberProfileAvatar
                    id={value as string}
                    circleClassName=" !w-6 !h-6  "
                  />
                )}
              </div>
            ) : (
              <span className="font-normal text-sm leading-[21px] text-[#BDC0C3]">
                -
              </span>
            )}
          </button>
        }
        selectedValue={value}
        updateValue={(member: IMemberList) => {
          handleSelect(member);
        }}
        handleSelectAll={handleSelectAll}
        options={members}
        isFullWidth
        hideRole
        hideSearchIcon
        showSearch={false}
        isMultiSelect={isMultiSelect}
      />
    </div>
  );
};

export default TeamMemberSelection;

